import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Set the scroll position to the top
  }, [pathname]); // Run this effect whenever the path changes

  return null; // This component doesn't render anything
};

export default ScrollToTop;
